import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { selectFilteredStationData } from '../../redux/station-data/station-data.selectors';

const SearchMessage = ({ filteredStationData }) => {
  let currentStationCount = 0;

  currentStationCount = filteredStationData.visibleMarkers.length;

  return (
    <div className="station-map-search-summary__container">
      <p className="station-map-search-summary__message">
        Showing <strong>{currentStationCount} station{(currentStationCount === 1) ? null : 's'}</strong>.
      </p>
    </div>
  );
};

SearchMessage.propTypes = {
  "filteredStationData": PropTypes.object
};

const mapStateToProps = (state) => {
  return {
    "filteredStationData": selectFilteredStationData(state)
  }
};

export default connect(mapStateToProps)(SearchMessage);